const o = "styles-module__mobileChatButtonContainer___iJ6Kx", e = "styles-module__open___dS7di", n = "styles-module__mobileDropdownContainer___u5VKG", t = "styles-module__mobileDropdownItem___R41Pz", _ = "styles-module__mobileDropdownItemIcon___YKUN5", l = {
  mobileChatButtonContainer: o,
  open: e,
  mobileDropdownContainer: n,
  mobileDropdownItem: t,
  mobileDropdownItemIcon: _
};
export {
  l as default,
  o as mobileChatButtonContainer,
  n as mobileDropdownContainer,
  t as mobileDropdownItem,
  _ as mobileDropdownItemIcon,
  e as open
};
